export const LOOKUP_NAME_BASE = {
    id: "lookup-name",
    field: "name",
    dataField: "name",
    value: ""
  }